import { useEffect } from 'react'

import { useDocumentStore } from '../../../Stores/useDocumentStore'
import { useQuotationMessageUpdateStore } from '../../../Stores/useQuotationMessageUpdateStore'
import { useQuotationStore } from '../../../Stores/useQuotationStore'
import { CONTEXT_DOCUMENT } from '../../../constants/contextDocument'
import { Trash } from '../../Icons'
import { FileProps } from './TableAttachment'
import { documentOptionsUpload, sharedDocuments } from './documentsOptions'

type Props = {
  item: FileProps
  context: string
}

export const RowAttachmentReadOnly = ({ context, item }: Props) => {
  const { deleteAttachments } = useQuotationStore()
  const { deleteUpdateAttachments } = useQuotationMessageUpdateStore()
  const { removeDocument } = useDocumentStore()

  const documentOptions =
    context === CONTEXT_DOCUMENT.CONFIRMATION_UPLOAD
      ? documentOptionsUpload
      : sharedDocuments

  const handleDeleteFile = (id: number) => {
    if (context === CONTEXT_DOCUMENT.QUOTATION_REQUEST) {
      deleteAttachments(id)
    } else if (context === CONTEXT_DOCUMENT.QUOTATION_UPDATE) {
      deleteUpdateAttachments(id)
    } else if (context === CONTEXT_DOCUMENT.CONFIRMATION_UPLOAD) {
      removeDocument(id.toString())
    }
  }

  useEffect(() => {
    return () => URL.revokeObjectURL(item?.preview!)
  }, [])

  return (
    <>
      <tr>
        <td>{item.id}</td>
        <td className="ellipse-text">{item?.name}</td>
        <td className="td-right">
          {documentOptions.find((i) => i.value === item.type)?.caption}
        </td>
        <td>
          <div className="action">
            <button
              className="button"
              onClick={() => handleDeleteFile(item.id)}
            >
              <Trash />
            </button>
          </div>
        </td>
      </tr>
    </>
  )
}
